import { AppEventProviderContext } from "../constants"
import { AppEventProviderProps } from "../hooks/useAppEventProvider"

const AppEventProviderView: React.FC<React.PropsWithChildren<AppEventProviderProps>> = ({ events, children, ...actions }) => {
    return <AppEventProviderContext.Provider value={{ events, ...actions }}>{children}</AppEventProviderContext.Provider>
}
export default AppEventProviderView
